import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Btn, { BtnModifier } from '../Btn';
import { sendLiveRegionMessage } from '../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { StatusInfoErrorWithRequestId } from '../../../_lib/components/StatusInfo';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

type RefetchBlock = {
  refetchBlock?: () => void;
  requestId?: string;
  modifier?: Modifier<'application'>; // different colors on dark application backgrounds
  errorTextTranslationKey?: string;
};

export function RefetchBlock({ refetchBlock, requestId, modifier, errorTextTranslationKey }: RefetchBlock) {
  const { t } = useTranslation('phrases');
  const [isInteraction, setIsInteraction] = useState(false);
  const [focusButtonOnNextRender, setFocusButtonOnNextRender] = useState(false);

  const errorText = t(errorTextTranslationKey || 'errorLoadingContentPleaseTryAgain');

  const isRefetchButtonVisible = errorTextTranslationKey !== 'surveyInProgress';

  useEffect(() => {
    sendLiveRegionMessage(errorText);
  }, [errorText]);

  const statusInfoColorModifier = modifier === 'application' ? 'red-application' : 'red';
  const buttonModifier =
    modifier === 'application' ? [BtnModifier.SINGLE_ACTION, BtnModifier.INVERTED] : [BtnModifier.SINGLE_ACTION];

  return (
    <div className={bem('refetch-block', modifier)}>
      {/* // warning messages after an interaction on the button are role="alert" */}
      {/* // all other are role="status" and not immediately read by screen readers */}
      <StatusInfoErrorWithRequestId
        modifier={[statusInfoColorModifier, 'center', 'margin-bottom-large']}
        requestId={requestId}
        message={errorText}
        role={isInteraction ? 'status' : 'alert'}
      />
      {refetchBlock && isRefetchButtonVisible
        ? (
            <div className="refetch-block__button">
              <Btn
                focusOnMount={focusButtonOnNextRender}
                text={t(`loadContent`)}
                type="button"
                onClick={() => {
                  setIsInteraction(true);
                  if (!focusButtonOnNextRender) {
                    setFocusButtonOnNextRender(true);
                  }
                  refetchBlock();
                }}
                modifier={buttonModifier}
              />
            </div>
          )
        : null}
    </div>
  );
}
